<div class="empty-space-container">
    <div class="loader-wrapper">
        <svg width="48px" height="48px" viewBox="0 0 28 28" style="enable-background:new 0 0 28 28;" xml:space="preserve">
          <path opacity="1" fill="#eee" d="M14,27C6.83,27,1,21.17,1,14S6.83,1,14,1c7.17,0,13,5.83,13,13S21.17,27,14,27z M14,3C7.93,3,3,7.93,3,14
                    s4.93,11,11,11s11-4.93,11-11S20.07,3,14,3z"/>
            <path [attr.fill]="fillColor" d="M14,1v2c6.07,0,11,4.93,11,11s-4.93,11-11,11v2c7.17,0,13-5.83,13-13S21.17,1,14,1z">
            <animateTransform attributeType="xml"
                              attributeName="transform"
                              type="rotate"
                              from="0 14 14"
                              to="360 14 14"
                              dur="1s"
                              repeatCount="indefinite"/>
          </path>
        </svg>
        Loading...
    </div>
</div>
